import useMode from '../../../../../utils/hooks/useMode';
import { EnumMode } from '../../../../../utils/context/Mode.context';
import { Stack } from '@mui/material';
import DashboardCard from '../../../../../components/dashboard-card/EndToEndCard.tsx/DashboardCard';
import EarningsChartCard from './components/EarningsChartCard/EarningsChartCard';
import NumbersSupplier from './components/NumbersSupplier';
import NumbersClient from './components/NumbersClient';
import ProjectPaymentGraphCard from './components/ProjectPaymentGraphCard';

const Stats = () => {
  const { mode } = useMode();
  return (
    <Stack
      width="100%"
      direction={{ md: 'column', lg: 'row' }}
      spacing={{ md: '20px', lg: '24px' }}
    >
      {mode === EnumMode.Supplier ? <EarningsChartCard /> : <ProjectPaymentGraphCard />}
      <DashboardCard
        mainStackSpacing={0}
        renderComponentSx={{
          height: '100%',
        }}
        renderComponent={mode === EnumMode.Supplier ? <NumbersSupplier /> : <NumbersClient />}
        sx={{
          width: { md: '100%', lg: '50%' },
          minHeight: '306px',
        }}
      />
    </Stack>
  );
};

export default Stats;
